export const US_GEOCODER_OPTION = 'us-geocoder';
export const VAT_RATE_OPTION = 'vat-rate';
export const ZIP_TAX_OPTION = 'zip-tax';

export const OPTIONS = [
  { value: US_GEOCODER_OPTION, translationKey: 'billing_tax_type_geocoder' },
  { value: ZIP_TAX_OPTION, translationKey: 'billing_tax_type_zip_tax' },
  { value: VAT_RATE_OPTION, translationKey: 'billing_tax_type_vat_rate' },
];
